import { RematchDispatch, RematchRootState } from '@rematch/core';
import { connect } from 'react-redux';
import { RootModel } from '../../../state';
import { EnterTabNameContainer } from './EnterTabNameContainer';
import * as Constants from '../../../utils/constants';

export const mapState = (state: RematchRootState<RootModel>) => {
  return {
    serviceDisplayName: state.services.service?.displayName,
    connectionName: state.connections.connection?.name,
    tabName: state.tab.tabName,
    isPw365Project:
      state.projects.project.solutionType ===
      Constants.SolutionTypes.projectWise365,
  };
};

export const mapDispatch = (dispatch: RematchDispatch<RootModel>) => ({
  setTabName: (tabName: string) => dispatch.tab.setTabName(tabName),
});

export const ConnectedEnterTabName = connect(
  mapState,
  mapDispatch
)(EnterTabNameContainer);
